define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var DnsZoneRecordModel = /** @class */ (function () {
        function DnsZoneRecordModel(data) {
            this.Name = ko.observable('');
            this.Type = ko.observable('CNAME');
            this.Value = ko.observable('');
            this.Values = ko.observable(''); //used for edit in textarea each value in new line
            this.Ttl = ko.observable(10);
            this.Weight = ko.observable(0);
            this.Region = ko.observable('');
            this.Geolocation = ko.observable('');
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, DnsZoneRecordModel.Mapping, self);
            }
        }
        DnsZoneRecordModel.Mapping = {
            key: function (data) {
                return data.Name;
            },
            create: function (options) {
                return new DnsZoneRecordModel(options.data);
            }
        };
        return DnsZoneRecordModel;
    }());
    return DnsZoneRecordModel;
});
//# sourceMappingURL=DnsZoneRecordModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/DnsZoneRecordModel.js
// module id = 244
// module chunks = 2